import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { saveAs } from 'file-saver'; // Necesitas instalar esta biblioteca
import { HttpClient } from '@angular/common/http';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { PlanificacionCumplimientoService } from '../../../services/planificacion-cumplimiento.service';
import { appsettings } from '../../../settings/appsettings';
import { DocumentosComponent } from "./documentos/documentos.component";

@Component({
  selector: 'app-banco-aspirantes',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, DocumentosComponent],
  templateUrl: './banco-aspirantes.component.html',
  styleUrl: './banco-aspirantes.component.css'
})
export class BancoAspirantesComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  resultado: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  isDocumento: boolean = false;
  id_estudiante: string = '';
  nombre_participante: string = '';

  estado: any = [];
  sel_edo!: number;

  private srvLogin = inject(InicioService);
  private servicios = inject(PlanificacionCumplimientoService);
  private http = inject(HttpClient);
  url = appsettings.apiUrl;

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.bancoAspirante('1').subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.resultado = rs.data.estudiantes;
        this.estado = rs.data.estado;
        this.sel_edo = 1;
        console.log('prueba:   ',rs.data.estudiantes)
        //console.log('cantidad:   ',rs.data.estudiantes.ocupaciones)

        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  // Método para filtrar la tabla
  buscarAccionFormativa() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const identificacion = item.identificacion ? this.quitarAcentos(item.identificacion.toLowerCase()) : '';
      const nombre = item.nombre_full ? item.nombre_full.toLowerCase() : '';
      const estado = item.estado ? this.quitarAcentos(item.estado.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        identificacion.includes(term) ||
        nombre.includes(term) ||
        estado.includes(term)
      );
    });
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  consulta_combos(){
    let estado = (document.getElementById('estado') as HTMLInputElement);
    this.mdl.cargando();
    this.servicios.bancoAspirante(estado.value).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.sel_edo = parseInt(estado.value);
        this.resultado = rs.data['estudiantes'];
        console.log('prueba:   ',rs.data)
        this.filteredResultado = [...this.resultado]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  imprimir(id_estudiante: string, identificacion: string){
    this.mdl.cargando();
    this.servicios.imprimir(id_estudiante).subscribe({
      next: (rs) => {
        this.mdl.cerrar();

        const ruta = `${this.url}/${rs.data[0]}`
        // Abre la URL en una nueva pestaña
        console.log('ruta: ',rs.data[0])

        if(rs.data[0] == null){
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Revise los datos del aspirante ('+identificacion+').';
          this.mdl.alerta();
        }
        else{
          this.http.get(ruta, { responseType: 'blob' }).subscribe(
            (response: Blob) => {
              // Usa la biblioteca file-saver para guardar el blob como un archivo
              saveAs(response, `${identificacion}.pdf`);
              console.log('PDF descargado con éxito.');

              this.servicios.borrarDocumento(identificacion).subscribe({
                next: (rs) => {
                  console.log('aaaaaa: ',rs.data)
                },
                error: (error) => {
                  this.errorMessage = error.message; // Muestra el mensaje de error al usuario
                }
              });

            },
            (error) => {
              console.error('Error al descargar el PDF:', error);
            }
          );
        }




      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  documento(id_estudiante: string, nombre: string, identificacion: string){
    this.id_estudiante = id_estudiante;
    this.nombre_participante = `${identificacion} - ${nombre}`;
    this.isDocumento = true;
  }

  volver(rsl: any) {
    this.isDocumento = rsl.value;
    if(rsl.validador){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = `Este aspirante (${this.nombre_participante}) no ha cargado documentos!`;
      this.mdl.alerta();
    }
  }

}
